import Footer from "./Footer";
import Content from "./Content";
import { Outlet } from "react-router-dom";
import SimpleHeader from "./SimpleHeader";

const SignUpLayout = () => {
  return (
    <div>
      <SimpleHeader />
      <Content>
        <Outlet />
      </Content>
      <Footer />
    </div>
  );
};

export default SignUpLayout;
